<article class="kanban-card-reconciled" (click)="clickCard.emit()">
  <header class="kanban-card-reconciled__header">
    <h3 class="kanban-card-reconciled__header__title">{{ tittle() }}</h3>
  </header>
  <main class="kanban-card-reconciled__content">
    <section class="kanban-card-reconciled__content__row">
      <div class="kanban-card-reconciled__content__column">
        <b>{{ order()?.date | date }}</b>
        @if(!sendWithoutNf()) { Pedido de compra }
      </div>
      <b class="kanban-card-reconciled__content__amount">{{ order()?.amount | currency : 'BRL' }}</b>
    </section>

    @if(nf() && !sendWithoutNf()) {
    <section class="kanban-card-reconciled__content__row">
      <div class="kanban-card-reconciled__content__column">
        <b>{{ nf()?.date | date }}</b>
        NF-e {{ nf()?.code || 'N/A' }}
      </div>

      <b class="kanban-card-reconciled__content__amount">{{ nf()?.amount | currency : 'BRL' }}</b>
    </section>
    }
    <section class="kanban-card-reconciled__content__column">
      <b>Seller</b>
      <span>{{ branchName() }}</span>
    </section>

    @if (sendWithoutNf()) {
    <section class="kanban-card-reconciled__content__row">
      <div class="kanban-card-reconciled__content__column">
        <b>Nº da NF-e (inserção manual)</b>
        {{ nf()?.code || 'N/A' }}
      </div>
      <span class="kanban-card-reconciled__content__flag">
        <div class="kanban-card-reconciled__content__flag__icon icon">info</div>
        <b>Enviado sem Nota</b>
      </span>
    </section>
    }
  </main>
</article>
